import { useEffect, useState } from 'react';
import flatpickr from 'flatpickr';
import 'flatpickr/dist/flatpickr.min.css';
import VehicleSearchBox from './VehicleSearchBox';
import posthog from 'posthog-js';

const DatePickerInput = ({ headerText, onDateChange, initialDate, showFilterByVehicleNumber = false, isRestricted }) => {
  const today = new Date();
  const yesterday = new Date(today);
  yesterday.setDate(today.getDate() - 1);
  const defaultRestrictedDate = yesterday.toLocaleDateString('en-US', { month: '2-digit', day: '2-digit', year: 'numeric' }).replace(/(\d+)\/(\d+)\/(\d+)/, '$1/$2/$3');
  const defaultUnrestrictedDate = "04/30/2025";

  const [selectedDate, setSelectedDate] = useState(
    initialDate || (isRestricted ? defaultRestrictedDate : defaultUnrestrictedDate)
  );

  useEffect(() => {
    const maxDate = isRestricted ? new Date(today) : new Date('2025-07-20');
    maxDate.setDate(maxDate.getDate() - (isRestricted ? 1 : 0));

    const picker = flatpickr("#datePicker", {
      defaultDate: selectedDate,
      dateFormat: "m/d/Y",
      minDate: isRestricted ? new Date("2025-05-15") : new Date("2019-04-02"),
      maxDate: maxDate,
      onChange: (selectedDates, dateStr) => {
        setSelectedDate(dateStr);
        onDateChange(dateStr);

        // PostHog tracking for selected date
        posthog.capture('date_selected_dashboard', {
          selected_date: dateStr,
          user_id: localStorage.getItem("tensor-user-id") || "unknown"
        });
      },
    });

    return () => {
      picker.destroy(); // Clean up flatpickr on unmount
    };
  }, [onDateChange, selectedDate, isRestricted]);

  return (
    <section className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 mb-6">
      <h2 className="text-2xl font-bold page_head_text">{headerText}</h2>

      <div className="flex flex-col sm:flex-row items-end gap-4 w-full sm:w-auto">
        {showFilterByVehicleNumber && (
          <VehicleSearchBox />
        )}
        <input
          type="text"
          id="datePicker"
          placeholder="Pick a date"
          value={selectedDate}
          className="px-4 py-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 h-[42px] w-full sm:w-auto"
        />
      </div>
    </section>
  );
};

export default DatePickerInput;
